<template>
  <div>
    <div class="nav-bar" role="presentation">
      <button
        v-if="navBarPoi && navBarPoi.prev"
        @click="$emit('prev')"
        class="prev-poi main-background"
      >
        <i aria-hidden="true" class="material-icons">chevron_left</i>
        <span>{{ $t('poiView.priorStop') }}</span>
      </button>
      <div class="btn-container" role="presentation">
        <button
          class="btn btn-primary share-background secondary-text user-select-none"
          @click="sharing = !sharing"
        >
          <i aria-hidden="true" class="material-icons">share</i>
          <span>{{ $t('button.share') }}</span>
        </button>
      </div>
      <button
        v-if="navBarPoi && navBarPoi.next"
        @click="$emit('next')"
        class="next-poi main-background"
      >
        <span>{{ $t('poiView.nextStop') }}</span>
        <i aria-hidden="true" class="material-icons">chevron_right</i>
      </button>
    </div>
    <div v-if="sharing" class="social-media-poi" role="presentation">
      <share-block :url="poiUrl"
                 :title="$tr(poi.name)"
                 :description="$tr(poi.information)"
                 @close="sharing = false"></share-block>
    </div>
  </div>
</template>

<script>
import ShareBlock from '@/views/ShareBlock'

import { mapState } from 'vuex'

export default {
  name: 'PoiNavbar',
  props: ['navBarPoi'],
  data: function () {
    return {
      sharing: false
    }
  },
  components: {
    'share-block': ShareBlock
  },
  computed: {
    poiUrl: function () {
      return `${window.location.origin}${this.$route.fullPath}`
    },
    ...mapState('poi', {
      poi: state => state.currentPoi
    })
  }
}
</script>
